import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MadCloudResult } from '@common/http/models/mad-cloud-result.model';
import { ApiService } from '@portal-core/auth/services/api.service';
import { ConnectorLookup } from '@portal-core/publications/models/connector-lookup.model';
import { ConnectorUpdate } from '@portal-core/publications/models/connector-update.model';
import { Connector } from '@portal-core/publications/models/connector.model';
import { SharePendingRequest } from '@portal-core/util/observables.decorators';
import { Observable } from 'rxjs';
import { DestinationWithConnector } from '@portal-core/publications/models/destination-with-connector.model';

@Injectable({
  providedIn: 'root'
})
export class ConnectorApiService {
  constructor(private http: HttpClient, private apiService: ApiService) { }

  @SharePendingRequest()
  getLicenseConnectors$(licenseId: number): Observable<Connector[]> {
    return this.http.get<Connector[]>(`${this.apiService.centralApiBaseUri}/api/Connectors/License/${licenseId}`);
  }

  getUserConnectors$(licenseId: number): Observable<Connector[]> {
    return this.http.get<Connector[]>(`${this.apiService.centralApiBaseUri}/api/Connectors/License/${licenseId}/User`);
  }

  createConnector$(connector: Partial<ConnectorUpdate>): Observable<MadCloudResult> {
    return this.http.post<MadCloudResult>(`${this.apiService.centralApiBaseUri}/api/Connectors`, connector);
  }

  updateConnector$(connector: Partial<ConnectorUpdate>): Observable<MadCloudResult> {
    return this.http.put<MadCloudResult>(`${this.apiService.centralApiBaseUri}/api/Connectors/${connector.Id}`, connector);
  }

  deleteConnectors$(connectorIds: number[]): Observable<MadCloudResult> {
    return this.http.post<MadCloudResult>(`${this.apiService.centralApiBaseUri}/api/Connectors/DeleteConnectors`, connectorIds);
  }

  getDestinationWithConnector$(projectId: number, branchName: string, filePath: string, allowUserConnectors: boolean): Observable<DestinationWithConnector> {
    return this.http.post<DestinationWithConnector>(`${this.apiService.centralApiBaseUri}/api/Connectors/Project/${projectId}/Destination`, {
      BranchName: branchName,
      FilePath: filePath,
      AllowUserConnectors: allowUserConnectors
    });
  }
}
